import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {EChartsOption} from 'echarts';
import {ScoreDevelopmentChipVm, ScoreDevelopmentVm} from '../../models/team-dynamic.vm';

@Component({
  selector: 'app-score-development',
  templateUrl: './score-development.component.html',
  styleUrls: ['./score-development.component.scss']
})
export class ScoreDevelopmentComponent implements OnChanges {
  @Input() scores: ScoreDevelopmentVm = {labels: [], values: []};
  @Input() chips: ScoreDevelopmentChipVm[] = [];
  @Input() activeChipUuid: string | null = null;
  @Input() loading: boolean = false;

  @Output() chipSelected = new EventEmitter<string | null>();

  hasData: boolean = false;
  showChart: boolean = true;

  chartOption: EChartsOption = {
    xAxis: {
      type: 'category',
      axisLabel: {
        color: '#000000',
        fontWeight: 400,
      },
      data: [],
    },
    yAxis: {
      type: 'value',
      max: 100,
      min: 0,
      axisLabel: {
        color: '#000000',
        fontWeight: 400,
      },
    },
    tooltip: {
      trigger: 'axis'
    },
    series: [
      {
        name: '',
        label: {
          // @ts-ignore
          normal: {
            show: false,
            position: 'top'
          },
        },
        data: [],
        type: 'line',
        symbolSize: 10,
        smooth: true,
        color: '#19AEFF',
        tooltip: {
          trigger: 'axis',
        },
      },
    ],
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['scores'] || changes['activeChipUuid'] || changes['chips']) {
      this.fillChart();
    }
  }

  selectChip(chip: ScoreDevelopmentChipVm) {
    this.chipSelected.emit(chip.uuid);
  }

  trackByUuid(index: number, chip: ScoreDevelopmentChipVm) {
    return chip.uuid ?? index;
  }

  private fillChart() {
    const labels = this.scores?.labels ?? [];
    const values = this.scores?.values ?? [];
    this.hasData = values.length > 0;

    // @ts-ignore
    this.chartOption.series[0].name = this.getActiveChipTitle();
    // @ts-ignore
    this.chartOption.series[0].data = [];
    // @ts-ignore
    this.chartOption.xAxis.data = [];

    labels.forEach((label: string, index: number) => {
      // @ts-ignore
      this.chartOption.xAxis.data.push(label);
      // @ts-ignore
      this.chartOption.series[0].data.push({value: values[index], name: label});
    });

    this.showChart = !this.showChart;
  }

  private getActiveChipTitle(): string {
    return this.chips.find(chip => chip.uuid === this.activeChipUuid)?.title ?? '';
  }
}
